
















import Vue from 'vue'
import Component from 'vue-class-component'

import Navigation from './components/Navigation.vue'

@Component({
  components: {
    Navigation
  }
})
export default class App extends Vue {
  $refs!: {
    navigation: Navigation;
  }

  hideDropdown (evt: MouseEvent) {
    if (evt.target instanceof HTMLAnchorElement) {
      return
    }

    this.$refs.navigation.hideDropdown(evt)
  }
}
